module.exports = __webpack_public_path__ + "img/collection-memoireRingsRedgold@2x.171f3ab.jpg";